import { useEffect, useState } from "react";
import Banner from "../../sections/common/banner";
import { bannerData } from "../../../globals/banner";
import { careersData } from "../../../globals/careersData";
import { loadScript } from "../../../globals/constants";
import "./careers.css";

function CareersPage() {
    const [activeTab, setActiveTab] = useState("fulltime");

    useEffect(() => {
        loadScript("js/custom.js");
    }, []);

    const currentRoles = activeTab === "fulltime"
        ? careersData.fullTimeRoles
        : careersData.internshipRoles;

    return (
        <>
            <Banner _data={bannerData.careers} />

            {/* Why Join Us Section */}
            {/* <div className="section-full p-t80 p-b50 bg-white">
                <div className="container">
                    <div className="section-head center">
                        <div className="sx-head-s-title">Why Join Infotrace</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">Build Your Career With Us</h2>
                        </div>
                    </div>
                    <div className="section-content">
                        <p className="text-center" style={{ maxWidth: "800px", margin: "0 auto 40px" }}>
                            At Infotrace Analytics, we're passionate about data and innovation. Join our team of talented professionals
                            and work on cutting-edge projects that make a real impact. We offer a collaborative environment where your
                            ideas matter and your growth is our priority.
                        </p>
                        <div className="row">
                            {careersData.benefits.map((benefit, index) => (
                                <div className="col-lg-4 col-md-6 m-b30" key={index}>
                                    <div className="sx-icon-bx-2">
                                        <div className="sx-media">
                                            <i className={benefit.icon} />
                                        </div>
                                        <div className="sx-icon-bx-info">
                                            <span className="sx-icon-bx-title">{benefit.title}</span>
                                            <p className="sx-icon-bx-title-info">{benefit.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Open Positions Section */}
            <div className="section-full p-t80 p-b50 bg-gray">
                <div className="container">
                    <div className="section-head center">
                        <div className="sx-head-s-title">Open Positions</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">Find Your Perfect Role</h2>
                        </div>
                    </div>

                    {/* Tab Navigation - Only show if there are roles */}
                    {(careersData.fullTimeRoles.length > 0 || careersData.internshipRoles.length > 0) && (
                        <div className="text-center m-b40">
                            <div className="btn-group" role="group">
                                <button
                                    type="button"
                                    className={`site-button ${activeTab === "fulltime" ? "active" : "outline-primary"}`}
                                    onClick={() => setActiveTab("fulltime")}
                                    style={{ marginRight: "10px" }}
                                >
                                    Full-Time Positions
                                </button>
                                <button
                                    type="button"
                                    className={`site-button ${activeTab === "internship" ? "active" : "outline-primary"}`}
                                    onClick={() => setActiveTab("internship")}
                                >
                                    Internship Programs
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Job Listings */}
                    <div className="section-content">
                        <div className="row">
                            {currentRoles.length > 0 ? (
                                currentRoles.map((role) => (
                                    <div className="col-lg-6 col-md-12 m-b30" key={role.id}>
                                        <div className="sx-box career-card" style={{
                                            padding: "30px",
                                            background: "#fff",
                                            borderRadius: "8px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                            height: "100%",
                                            transition: "transform 0.3s ease, box-shadow 0.3s ease"
                                        }}>
                                            <div className="career-header" style={{ marginBottom: "20px" }}>
                                                <h3 className="sx-title" style={{ marginBottom: "10px", fontSize: "22px" }}>
                                                    {role.title}
                                                </h3>
                                                <div className="career-meta" style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "15px",
                                                    fontSize: "14px",
                                                    color: "#666"
                                                }}>
                                                    <span><i className="feather-briefcase" style={{ marginRight: "5px" }} />{role.department}</span>
                                                    <span><i className="feather-map-pin" style={{ marginRight: "5px" }} />{role.location}</span>
                                                    <span><i className="feather-clock" style={{ marginRight: "5px" }} />{role.type}</span>
                                                    {role.duration && (
                                                        <span><i className="feather-calendar" style={{ marginRight: "5px" }} />{role.duration}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>{role.description}</p>
                                            <div className="career-details">
                                                <h4 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "10px" }}>
                                                    Key Responsibilities:
                                                </h4>
                                                <ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
                                                    {role.responsibilities.slice(0, 3).map((resp, idx) => (
                                                        <li key={idx} style={{ marginBottom: "8px", lineHeight: "1.5" }}>{resp}</li>
                                                    ))}
                                                </ul>
                                                <h4 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "10px" }}>
                                                    Requirements:
                                                </h4>
                                                <ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
                                                    {role.requirements.slice(0, 3).map((req, idx) => (
                                                        <li key={idx} style={{ marginBottom: "8px", lineHeight: "1.5" }}>{req}</li>
                                                    ))}
                                                </ul>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginTop: "20px",
                                                    paddingTop: "20px",
                                                    borderTop: "1px solid #eee"
                                                }}>
                                                    <span style={{ fontSize: "13px", color: "#999" }}>
                                                        Posted: {new Date(role.postedDate).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })}
                                                    </span>
                                                    <a
                                                        href={`mailto:careers@infotraceanalytics.com?subject=Application for ${role.title}`}
                                                        className="site-button"
                                                    >
                                                        Apply Now
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-lg-12">
                                    <div className="text-center p-t50 p-b50" style={{
                                        background: "#fff",
                                        borderRadius: "15px",
                                        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                                        padding: "60px 20px"
                                    }}>
                                        <div className="m-b30">
                                            <i className="feather-briefcase" style={{
                                                fontSize: "64px",
                                                color: "#007DB6",
                                                opacity: "0.5"
                                            }} />
                                        </div>
                                        <h3 className="sx-title m-b20">No Open Positions Currently</h3>
                                        <p style={{
                                            maxWidth: "600px",
                                            margin: "0 auto 30px",
                                            fontSize: "16px",
                                            color: "#666",
                                            lineHeight: "1.6"
                                        }}>
                                            We don't have any open positions at the moment, but we're always looking for talented individuals to join our team.
                                            Stay tuned for future opportunities or send us your CV for our talent pool.
                                        </p>
                                        <a
                                            href="mailto:careers@infotraceanalytics.com?subject=Speculative Application / Talent Pool"
                                            className="site-button"
                                        >
                                            Submit Your CV
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Application Process Section */}
            <div className="section-full p-t80 p-b50 bg-white">
                <div className="container">
                    <div className="section-head center">
                        <div className="sx-head-s-title">Application Process</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">How to Apply</h2>
                        </div>
                    </div>
                    <div className="section-content">
                        <div className="row justify-content-center">
                            {careersData.applicationProcess.map((process, index) => (
                                <div className="col-lg-2 col-md-4 col-sm-6 m-b30" key={index}>
                                    <div className="text-center">
                                        <div className="sx-icon-bx-circle" style={{
                                            width: "80px",
                                            height: "80px",
                                            borderRadius: "50%",
                                            background: "linear-gradient(135deg, #007DB6 0%, #005a87 100%)",
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "32px",
                                            fontWeight: "700",
                                            margin: "0 auto 20px",
                                            boxShadow: "0 4px 15px rgba(0, 125, 182, 0.3)"
                                        }}>
                                            {process.step}
                                        </div>
                                        <h4 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "10px" }}>
                                            {process.title}
                                        </h4>
                                        <p style={{ fontSize: "14px", color: "#666", lineHeight: "1.5" }}>
                                            {process.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="section-full p-t80 p-b80 bg-primary text-white">
                <div className="container">
                    <div className="text-center">
                        <h2 className="sx-title" style={{ color: "#fff", marginBottom: "20px" }}>
                            Ready to Join Our Team?
                        </h2>
                        <p style={{ fontSize: "18px", marginBottom: "30px", maxWidth: "700px", margin: "0 auto 30px" }}>
                            Send your CV and cover letter to our HR team. We're excited to hear from you!
                        </p>
                        <a
                            href="mailto:careers@infotraceanalytics.com"
                            className="site-button"
                            style={{
                                background: "#fff",
                                color: "#007DB6",
                                padding: "15px 40px",
                                fontSize: "16px",
                                fontWeight: "600"
                            }}
                        >
                            <i className="feather-mail" style={{ marginRight: "10px" }} />
                            careers@infotraceanalytics.com
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CareersPage;
